// extracted by mini-css-extract-plugin
module.exports = {"textButtonContainer":"ShowRateHistory_textButtonContainer__mJdBL","textButton":"ShowRateHistory_textButton__2wWGR"};